/**
 * Busca endereço pelo CEP na API dos Correios (ViaCEP).
 * https://viacep.com.br/
 * @param {string} cep - CEP com ou sem máscara (apenas 8 dígitos)
 * @returns {Promise<{ logradouro?: string, bairro?: string, localidade?: string, uf?: string, erro?: boolean }>}
 */
export async function buscarPorCep(cep) {
  const digits = String(cep || '').replace(/\D/g, '');
  if (digits.length !== 8) {
    return { erro: true };
  }
  try {
    const res = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
    const data = await res.json();
    if (data.erro === true) return { erro: true };
    return {
      logradouro: data.logradouro || '',
      bairro: data.bairro || '',
      localidade: data.localidade || '',
      uf: data.uf || ''
    };
  } catch (err) {
    console.warn('ViaCEP error:', err);
    return { erro: true };
  }
}
